export enum PaymentStatuses {
  UNAPPLIED = 'unapplied',
  PARTIALY_UNAPPLIED = 'partialy_unapplied',
  CLOSED = 'closed'
}
